import React from "react";
import { Avatar, Badge, Button, Card, message } from "antd";
import { MailOutlined, PhoneOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { updateUser } from "../../../redux/User/actions";
import ShowUser from "./ShowUser";
import EditUser from "./EditUserButton";
import DeleteUser from "./DeleteUserButton";
import { Grid } from "@material-ui/core";
import { RiAdminFill, RiUser3Fill } from 'react-icons/ri';

//"/Client/:id"
const UserCard = ({ item }) => {
  const user_id = useSelector((state) => state.auth.user?._id);
  const dispatch = useDispatch();

  // Check if item is defined before accessing its properties
  if (!item) {
    return null;
  }



  return (
    <Card
      title={
        item.isActive ? (
          <Badge status="success" text="Activé" />
        ) : (
          <Badge status="error" text="Désactivé" />
        )
      }
      style={{
        marginBottom: 15,
        minWidth: 300,
        boxShadow: "1px 1px 1px #9E9E9E",
        borderRadius: "5px",
      }}
      bordered={true}
      extra={
        <Button >
          <span style={{ color: item.isActive ? "blue" : "red" }}>
          {item.isActive ? "Active" : "Inactive"}
                        </span>
          
        </Button>
      }
      actions={[
        <ShowUser item={item} key="view" />,
        <EditUser item={item} key="edit" />,
        <DeleteUser item={item} key="delete" />,
      ]}
    >
      <Grid container direction="column" justify="center" alignItems="center">
        <Avatar
          size="large"
          style={{ cursor: "pointer", backgroundColor: "#3c8dbc" }}
          icon={item.roles[0].name === 'gerant' ? <RiAdminFill /> : <RiUser3Fill />}
        />
        <h1>{item.username}</h1>
        <label>
          <MailOutlined />
          &nbsp; {item.email}
        </label>
        {item.phone ? (
          <label>
            <PhoneOutlined />
            &nbsp;
            {item.phone}
          </label>
        ) : (
          <label> &nbsp; </label>
        )}
      </Grid>
    </Card>
  );
}

export default UserCard;
